import BaseService from "./base.service";

export default class DepartmentService extends BaseService {
    constructor(ctx) {
        super(ctx)
    }

    getDepartmentList = (query) => {
        return this.get('/department/list', query)
    }

    getOptionDepartment = (query) => {
        return this.get('/department/get-options', query)
    }

    getDepartmentsByBusiness = (query) => {
        return this.get('/department/by-business', query)
    }

    getDepartment = (query) => {
        return this.get('/department', query)
    }

    getDepartmentDetail = (query) => {
        return this.get('/department/detail', query)
    }
}
